export default __webpack_public_path__ + "static/media/banners_9.ce4641a5.png";